import React, { useContext, useEffect, useState } from 'react'
import TableView from '../../component/common/tableView'
import { useDispatch, useSelector } from 'react-redux'
import { itemRender } from '../../helper/paginationfunction'
import { SpinnerContext } from '../../context/spinnerContext'
import { deletecleanerReportCategory, getCleanerReportCategory } from '../../redux/slices/cleanerReportSlice'
import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react'
import CustomModal from '../../component/customModal'
import AddEditCleanerReportCategory from './addEditCleanerReportCategory'
import DeletePopup from '../../component/deletePopup'
import { errorToast, successToast } from '../../util/Toast/toast'

const CleanerReportCategory = () => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { allCleanerReportCategoryData } = useSelector(({ cleanerReport }) => cleanerReport)
  const [pagesize, setPagesize] = useState(10)
  const [page, setPage] = useState(1)
  const [isRefresh, setIsRefresh] = useState(true)
  const [editData, setEditData] = useState([])
  const [cleanerReportCategoryID, setCleanerReportCategoryID] = useState(null)

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen)

  const [showModal, setShowModal] = useState(false)
  const toggleModal = () => setShowModal(!showModal)

  useEffect(() => {
    if (!isRefresh) {
      return
    }
    const params = {
      page,
      limit: pagesize,
      sort_column: 'created_at',
      sort_order: 'DESC'
    }

    changeLoader(true)
    dispatch(getCleanerReportCategory(params))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(false)
        } else {
          errorToast(payload?.data?.status_message || 'Somthing went wrong!')
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
        setIsRefresh(false)
      })
  }, [page, pagesize, isRefresh])

  const onDelete = () => {
    setIsRefresh(false)
    if (cleanerReportCategoryID) {
      changeLoader(true)
      dispatch(deletecleanerReportCategory(cleanerReportCategoryID)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(true)
          openDeleteModal()
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          openDeleteModal()
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  const handlePagination = async (page, pageSize) => {
    setPage(page)
    setPagesize(pageSize)
    setIsRefresh(true)
  }

  const columns = [
    {
      title: 'No',
      render: (value, item, index) => (page - 1) * pagesize + (index + 1)
    },
    {
      title: 'Category',
      dataIndex: 'category',
      render: (text) => (text ? text : '-')
    },
    {
      title: 'Action',
      render: (record) => (
        <div className="d-flex align-items-center">
          {
            <Link
              className="btn-action-icon me-2 edit_icon_div"
              onClick={(event) => {
                event.stopPropagation()
                setCleanerReportCategoryID(record?.cleaning_reports_category_id)
                const filtered = allCleanerReportCategoryData?.find(
                  (user) => user?.cleaning_reports_category_id === record?.cleaning_reports_category_id
                )
                setEditData(filtered)
                toggleModal()
              }}
            >
              <i className="fe fe-edit d-flex align-items-center justify-content-center" style={{ color: 'primary' }}>
                <FeatherIcon icon="edit" className="icon-primary" />
              </i>
            </Link>
          }
          {
            <Link
              className="btn-action-icon delete_icon_div"
              onClick={(event) => {
                event.stopPropagation()
                setCleanerReportCategoryID(record?.cleaning_reports_category_id)
                openDeleteModal()
              }}
            >
              <i className="fe fe-trash-2 d-flex align-items-center justify-content-center">
                <FeatherIcon icon="trash-2" color="red" />
              </i>
            </Link>
          }
        </div>
      )
    }
  ].filter(Boolean)

  return (
    <div className="page-wrapper customers">
      <div className="content container-fluid">
        <div className="page-header">
          <div className="content-page-header">
            <h5>Cleaner Report Category</h5>
            <div className="list-btn">
              <ul className="filter-list">
                {/* <li>
                  <Link className="btn btn-filters w-auto popup-toggle" onClick={() => setShowFilter(!showFilter)}>
                    <span className="me-2">
                      <img src={FilterIcon} alt="filter" />
                    </span>
                    Filter{' '}
                  </Link>
                </li> */}
                <li>
                  <Button
                    className="btn btn-primary"
                    onClick={() => {
                      setEditData(null)
                      setCleanerReportCategoryID(null)
                      toggleModal()
                    }}
                  >
                    <i className="fa fa-plus-circle me-2" aria-hidden="true" />
                    Add Cleaner Report Category
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="table-card-div">
              <div className="card-table">
                <div className="card-body purchase">
                  <div className="table-responsive table-hover">
                    <TableView
                      columns={columns}
                      scroll={allCleanerReportCategoryData?.length > 0 ? { x: true } : false}
                      dataSource={allCleanerReportCategoryData || []}
                      paginationConfig={{
                        total: allCleanerReportCategoryData?.totalRecords || 0,
                        defaultPageSize: allCleanerReportCategoryData?.limit || 10,
                        defaultCurrent: allCleanerReportCategoryData?.currentpage || 1,
                        current: page,
                        pageSize: pagesize,
                        showSizeChanger: true,
                        pageSizeOptions: [10, 25, 50, 100],
                        onChange: (page, pageSize) => handlePagination(page, pageSize),
                        itemRender: itemRender
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <CustomModal
          isOpen={showModal}
          toggle={toggleModal}
          title={editData ? `Edit Cleaner Report Category` : `Add Cleaner Report Category`}
          size={'md'}
        >
          <AddEditCleanerReportCategory
            editData={editData}
            cleanerReportCategoryID={cleanerReportCategoryID}
            toggle={toggleModal}
            setIsRefresh={setIsRefresh}
          />
        </CustomModal>
      )}

      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger common-field-btn w-100" onClick={() => onDelete()}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </div>
  )
}

export default CleanerReportCategory
